import React from 'react';
import StartDateItem from "./start-date-item";

class StartDateGroup extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            city,
            groupedStartDates,
            moduleScheduleItem,
            resourcedTexts,
            handleCourseClick,
        } = this.props;

        const {selectedCourseId, sku} = moduleScheduleItem;

        return (
            <div className="start-date__group" key={city}>
                <h4 className="start-date__group-title">
                    {city}
                </h4>
                <div className='start-date__items'>
                    {groupedStartDates.map((groupedStartDate, i) => {
                        const {startDateList, courseId, typeOfDay} = groupedStartDate;

                        if (!startDateList || startDateList.length === 0) return null;

                        return (
                            <StartDateItem
                                key={i}
                                resourcedTexts={resourcedTexts}
                                courseId={courseId}
                                sku={sku}
                                typeOfDay={typeOfDay}
                                selectedCourseId={selectedCourseId}
                                startDateList={startDateList}
                                handleCourseClick={handleCourseClick}
                            />
                        )
                    })}
                </div>
            </div>
        )
    }
}

export default StartDateGroup;